import type { IMediaProvider, MediaType } from '@/models/Media';

const providers = new Map<string, IMediaProvider>();

export const mediaRegistry = {
  register(provider: IMediaProvider) {
    providers.set(provider.key, provider);
  },

  get(key: string): IMediaProvider | undefined {
    return providers.get(key);
  },

  defaultFor(type: MediaType): IMediaProvider | undefined {
    for (const provider of providers.values()) {
      if (provider.supportedTypes.includes(type) && provider.isConfigured()) {
        return provider;
      }
    }

    return undefined;
  },
};
